import r from "./highrise1312.mjs";
var a = r.Uint8Array;
export {
  a as default
};
